import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getEcommerce = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: '/ecommerce/list' });

  return data;
};

export default getEcommerce;
